// Api.
import api from './Base';
import LoginsDataTable from "../types/LoginsDataTable";
import { showError } from '../utils/showAlert';


const LoginApi = {

    getTags:async () => {

        let url = `login/tag`;

        let tags: any[] = [];

        await api.get<any[]>(url)
                .then((response) => {
                    tags = response.data;
                })
                .catch((error: any) => {
                    console.error('Failed to retrieve tags.', error);
                    showError('Failed to retrieve tags', error.message || error.toString());
                });
        return tags;
    },

    getLogins:async (id?: number) => {

        let url = `login`;
        if (id) {
            url += `?id=${id}`
        }

        let logins: LoginsDataTable[] = [];

        await api.get<LoginsDataTable[]>(url)
            .then((response) => {
                logins = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve logins.', error);
                showError('Failed to retrieve logins', error.message || error.toString());
            });
        return logins;
    }
}

export default LoginApi;